import {asyncLoad, asyncPost, asyncPatch, asyncDelete} from './.';

import * as helpers from 'helpers';

export const getInvoiceUrl = invoiceId =>
  `/invoices/${invoiceId}?fields=address1,address2,amountPaid,balanceDue,billToSourceId,dueDate,city,countryId,customerId,customerNotes,depositPaid,email,firstName,generatedByRecurring,invoiceId,invoiceNumber,invoiceStatusId,isRecurring,issuedDate,items,lastName,poNumber,primaryPhone,privateNotes,qualifiedName,recurringRuleId,serviceLocationId,state,taxableAmount,taxId,ticketId,totalAmount,totalCost,totalProfit,totalProfitMargin,totalROI,totalTime,totalTax,zip`;

export const loadInvoice = invoiceId => dispatch =>
  asyncLoad({
    dispatch,
    title: 'invoice',
    url: getInvoiceUrl(invoiceId),
  });

export const loadUnfilteredInvoices = () => dispatch =>
  asyncLoad({
    dispatch,
    title: 'invoice',
    url: `/invoices?fields=invoiceId&pageSize=1`,
  });

export const loadInvoices = ({
  sortInfo = {},
  pageInfo = {},
  statFilter,
  searchString,
  customViewId,
}) => dispatch => {
  const params = {
    pageSize: pageInfo.pageSize,
    rowIndex: helpers.rowIndexFromPage(pageInfo),
    sort: helpers.sortParam({
      sortColumn:
        sortInfo.sortColumn === 'InvoiceStatus'
          ? 'InvoiceStatusId'
          : sortInfo.sortColumn,
      sortOrder: sortInfo.sortOrder,
    }),
  };

  if (statFilter) {
    params.customFilter = statFilter;
  }

  if (searchString) {
    params.search = encodeURIComponent(searchString);
  } else {
    if (customViewId) {
      params.customFilterId = customViewId;
    }
  }

  return asyncLoad({
    dispatch,
    title: 'Invoices',
    url: `/invoices?fields=invoiceId,invoiceNumber,invoiceStatus,issuedDate,serviceLocationId,ticketId,qbStatusId,totalAmount,balanceDue,items{itemId},isRecurring,isCombined,generatedByRecurring,amountPaid,dueDate,name,email,address1,address2,city,state,zip,countryId,primaryPhone,recurringRuleId&includeCardTotals=true&${helpers.objectToParams(
      params,
    )}`,
  });
};

export const saveInvoice = ({
  invoice,
  updatedItems = null,
  patch = false,
}) => async dispatch => {
  const formObject = helpers.formValidation.setupFormBody(invoice, patch);

  if (formObject.hasError) {
    helpers.handleError(formObject.errorMessage, null, dispatch);
    return null;
  }

  if (patch) {
    try {
      const result = asyncPatch({
        body: formObject.body,
        dispatch,
        successMessage: 'The invoice has been updated successfully.',
        title: 'invoice',
        url: `/invoices/${invoice.invoiceId.value}`,
      });
      return result;
    } catch (err) {
      return null;
    }
  }

  let params = {};
  if (formObject.body.invoiceId) {
    params = {method: 'PUT'};
  }

  if (updatedItems) {
    formObject.body.items = updatedItems;
  }

  try {
    const result = await asyncPost({
      body: formObject.body,
      dispatch,
      params,
      successMessage: `The invoice has been ${
        formObject.body.invoiceId ? 'updated' : 'added'
      } successfully.`,
      title: 'invoice',
      url: `/invoices${
        formObject.body.invoiceId ? `/${formObject.body.invoiceId}` : ''
      }`,
    });

    return result;
  } catch (err) {
    return null;
  }
};

export const deleteInvoice = invoiceId => dispatch =>
  asyncDelete({
    dispatch,
    successMessage: 'The Invoice has been deleted successfully.',
    title: 'invoice',
    url: `/invoices/${invoiceId}`,
  });

export const loadSignature = invoiceId => dispatch =>
  asyncLoad({
    dispatch,
    title: 'signature',
    url: `/invoices/${invoiceId}/signature`,
  });

export const saveSignature = (signature, invoiceId) => dispatch =>
  asyncPost({
    body: {signature},
    dispatch,
    url: `/invoices/${invoiceId}/signature`,
    successMessage: 'The signature has been saved.',
  });

export const clearSignature = invoiceId => dispatch =>
  asyncDelete({
    dispatch,
    url: `/invoices/${invoiceId}/signature`,
    successMessage: 'The signature has been cleared.',
  });



// WEBPACK FOOTER //
// ./src/actions/invoiceActions.js